import { internalFetch } from '../utils/fetchHelper';
import { IPagedCollection } from '@moko/utils';

export interface IChat2CommandRequest {
  text: string;
}

export interface IChatCommand {
  action: string;
  entityType: string;
  code?: string;
  name?: string;
  others?: any;
  schemaValidationErrors?: string[];
}

export interface IChat2CommandResponse extends IChatCommand {
  error?: string;
}

export interface IChatQuery {
  id: number;
  request: string;
  favourite: boolean;
}

export const chat2Command = async (
  abortController: AbortController,
  request: IChat2CommandRequest
): Promise<IChat2CommandResponse> => {
  return internalFetch(
    `${import.meta.env.VITE_BACKEND_API_URL}/p/convertText`,
    'POST',
    abortController,
    JSON.stringify(request)
  );
};

export const getChatQueries = async (
  abortController: AbortController,
  pageSize: number,
  pageNo: number,
  orderBy?: string,
  search?: string
): Promise<IPagedCollection<IChatQuery>> => {
  return internalFetch(
    `${
      import.meta.env.VITE_BACKEND_API_URL
    }/p/chats?pageSize=${pageSize}&pageNo=${pageNo}${
      orderBy ? `&orderBy=${orderBy}` : ''
    }${search ? `&search=${search}` : ''}&code=${
      import.meta.env.VITE_BACKEND_API_KEY
    }`,
    'GET',
    abortController
  );
};

export const toggleChatQueries = async (
  abortController: AbortController,
  queryId: number
): Promise<boolean> => {
  return internalFetch(
    `${
      import.meta.env.VITE_BACKEND_API_URL
    }/p/favChat?queryId=${queryId}&code=${
      import.meta.env.VITE_BACKEND_API_KEY
    }`,
    'PUT',
    abortController
  );
};
